import { OccDeviation, OccDeviationService } from '../../occ-deviation';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { OccProfileService } from '../../occ-profile';

@Component({
    selector: 'app-occDeviation',
    templateUrl: './occ-deviation.component.html',
    styleUrls: ['./occ-deviation.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class OccDeviationComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private occDeviationService: OccDeviationService,
		private occProfileService: OccProfileService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
		this.dialogData = data,
			this.occDeviation = data.occDeviation,
			this.statuses = occDeviationService.statuses;
	}

	@Input() occDeviation: OccDeviation;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	occDeviationId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;
	dialogData: String;

	occProfileList : any = [];

	statuses: any;

	validationMessages = {
		occDeviationId: [],
		lowEndExpOccPCT: [
			{ type: 'required', message: 'Low End % is required' },
			{ type: 'min', message: 'Minimum value is 0%' },
			{ type: 'max', message: 'Maximum value is 100%' },
			{ type: 'pattern', message: 'Enter a valid percentage (e.g., 75.25)' }
		],
		highEndExpOccPCT: [
			{ type: 'required', message: 'High End % is required' },
			{ type: 'min', message: 'Minimum value is 0%' },
			{ type: 'max', message: 'Maximum value is 100%' },
			{ type: 'pattern', message: 'Enter a valid percentage (e.g., 80.00)' }
		],
		occProfileId: [
			{ type: 'required', message: 'Occupancy Profile is required' }
		]
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.loadOccProfileList();
		this.formBuild();

		 // Auto-select profile if passed from parent
		if (this.dialogData['selectedProfileId']) {
			this.form1.patchValue({
				occProfileId: this.dialogData['selectedProfileId']
			});
		}

		// if we were passed the whole occDeviation object
		if (this.occDeviation) {
			this.occDeviationId = this.occDeviation.occDeviationId;
			// Convert decimal to percentage before setting form values
			const patchedDeviation = {
				...this.occDeviation,
				lowEndExpOccPCT: this.occDeviation.lowEndExpOccPCT * 100,
				highEndExpOccPCT: this.occDeviation.highEndExpOccPCT * 100
			};
			this.form1.patchValue(patchedDeviation);
		}
	}

	loadOccProfileList()
	{
		try {
			this.occProfileService.findAll()
				.subscribe(
					(res: any) => {
						this.occProfileList = res.data.occProfiles;
					},
					(err: any) => {
						console.log('occMatrix-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.occDeviationId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			
			// Clone the form values and convert percentages to decimals
			const formData = { ...this.form1.value };
			formData.lowEndExpOccPCT = formData.lowEndExpOccPCT / 100;
			formData.highEndExpOccPCT = formData.highEndExpOccPCT / 100;
			
			this.formLoading = true;
			this.occDeviationService.add(formData)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.occDeviation = res.data.occDeviation;
						this.doAdd.emit(this.occDeviation);
					},
					(err: any) => {
						console.log('occDeviation-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('occDeviation: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			const payload = {
				...this.form1.value,
				lowEndExpOccPCT: this.form1.value.lowEndExpOccPCT / 100,
				highEndExpOccPCT: this.form1.value.highEndExpOccPCT / 100
			};

			this.formLoading = true;

			this.occDeviationService.update(payload)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.occDeviation = res.data.occDeviation;
						this.doUpdate.emit(this.occDeviation);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.occDeviationService.delete(this.occDeviation.occDeviationId)
				.subscribe(
					(res: any) => {
						console.log('occDeviation-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.occDeviation);
					},
					(err: any) => {
						console.log('occDeviation-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			occDeviationId: [this.occDeviationId],
			 lowEndExpOccPCT: ['', [
				Validators.required,
				Validators.min(-100),
				Validators.max(100),
				Validators.pattern('^-?[0-9]+(\\.[0-9]{1,2})?$')
			]],
			highEndExpOccPCT: ['', [
				Validators.required,
				Validators.min(-100),
				Validators.max(100),
				Validators.pattern('^-?[0-9]+(\\.[0-9]{1,2})?$')
			]],
			occProfileId: [null, Validators.required],
		});
	}
}
